import { Card, ModalPopup, PrimaryButton, ReactSelectBox, Search, SofturaTable, EventHandler } from "client/CommonComponents";
import excel from '../../../assets/images/Excel.svg'
import createNewAssessment from '../../../assets/images/Create New Order.svg'
import { DateRangePicker } from "rsuite";
import moment from "moment";
import './CatalogManagement.scss';
import ImportAsset from "./ImportAsset";
import { useNavigate } from "react-router-dom";
import permissions, { isAuthorized } from "client/utils/Permissions";
import { CATALOG_MANAGEMENT_ACTIVE_MENU } from "client/utils/constants/homeGridConstants";
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";

const CatalogManagement = (props:any) => {

    const {
        gridData,
        columnState,
        serverTotal,
        fetchAction,
        pagesCount,
        onSearchOrder,
        onDateRangeChange,
        searchValue,
        dateRange,
        setFilters,
        handleFilterClear,
        showGrid,
        globalStatusDropdownList,
        globalStatus,
        onChangeGlobalStatus,
        activeMenu,
        getGlobalSearchPlaceHolder,
        alreadyHasGridFilterValues,
        handleAddNewJobTitle,
        onClickChangeStatus,
        selectedIds,
        hideDialog,
        popupContent
    } = props;

    const navigate = useNavigate();
    
    return(
        <>       
        <div className='assessment-question CustomerMyOrder mt-1'>
            {activeMenu !== CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES && isAuthorized(permissions?.CreateEditCatalog) ?
             <div className='breadcrumb-toolbar'>
                        <button
                            className='create-new-order-btn me-2'
                            title='Create New Asset Type'
                            onClick={() => {
                                navigate(`/ordermanagement/catalogmanagement/createasset`)
                            }}
                            disabled={!isAuthorized(permissions?.CreateEditCatalog)}
                         data-attribute="CatalogManagement_Create_New_Asset_Type_Button">
                            <img src={createNewAssessment} alt='btn-icon' />
                            <span>Create New Asset Type</span>
                        </button>
            </div> 
            : null}
            <Card data-attribute="CatalogManagement_Default_Card">
                <div className='filter-catalog-mgmt-block'>
                    {props?.showActiveFilter.map((item:any,index:any)=>{
                        return (
                            <EventHandler onEvent={() => props?.handleOnClickFilter(item, index)} data-attribute={`CatalogManagement_${(item?.text || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}> <div className={`filter-block ${item?.isActive ? 'active' : ''}`} ><p>{item.text} ({item.count})</p></div></EventHandler>
                        )
                    })}
                </div>
                <div className='create-new-order-container'>                  
                    <div className='grid-block pt-2'>
                        <div className='mb-1 top-section catalog-top-section'>
                            <p>{activeMenu?.toUpperCase()}</p>
                            <div className='clearfix mt-sm-2'>
                                <div className={`pull-left searchblock catalog-search-box ${activeMenu == CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES ? "Jobtitle col-xl-4 col-md-3":""}`}>
                                    <Search 
                                        placeholder={getGlobalSearchPlaceHolder()}
                                        className='searchTextbox' 
                                        onSearch={(e?: any) => onSearchOrder(e, true)} 
                                        onBlur={(e?: any) => onSearchOrder(e, false)} 
                                        onChange={(e?: any) => onSearchOrder(e, false)} 
                                        value={searchValue}
                                         data-attribute="CatalogManagement_Default_Searchbox" />
                                </div>
                                
                                <div className={`pull-right datepickerControl create-flow mb-2 mb-sm-0 mt-sm-0 mt-0 catalog-date-range add_cancel_btns ${activeMenu == CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES ? "Jobtitleclass col-xl-4 col-md-7":""}`}>
                                        <PrimaryButton
                                            text='Change Status'
                                            disabled={!isAuthorized(permissions?.CreateEditCatalog) || selectedIds.length === 0}
                                            onClick={(e?: any) => onClickChangeStatus(e)}
                                            className='filter-btn ms-2 me-xl-2 me-lg-2 me-md-2 me-0  clear_filter_btn change_status'
                                         data-attribute="CatalogManagement_Default_Button" />
                                            <ReactSelectBox
                                                className='active-status-dropdown'
                                                options={globalStatusDropdownList}
                                                value={globalStatus}
                                                onChange={(e: any) => onChangeGlobalStatus(e)}
                                                placeholder="Select Status"
                                                defaultValue={{
                                                    "text": "All",
                                                    "value": "All",
                                                    "label": "All",
                                                    "key": "All"
                                                }}
                                             data-attribute="CatalogManagement_Default_SearchSelectBox" />
                                        {activeMenu !== CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES ?
                                            <DateRangePicker
                                                placement='bottomEnd'
                                                format="MM-dd-yyyy"
                                                character=' - '
                                                onChange={onDateRangeChange}
                                                placeholder='MM-DD-YYYY - MM-DD-YYYY'
                                                preventOverflow={true} value={dateRange}
                                                defaultCalendarValue={[new Date(moment().startOf('month').toDate()), new Date(moment().add(1, 'months').startOf('month').toDate())]}
                                             data-attribute="CatalogManagement_Default_DateRangePicker" />
                                       
                                        :
                                        (isAuthorized(permissions?.Create_Edit_JobTitle) || isAuthorized(permissions?.View_JobTitle)) ?
                                         <div>
                                            <PrimaryButton
                                                text='Add New'
                                                onClick={(e: any) => {handleAddNewJobTitle(e)}}
                                                className='filter-btn ms-2'
                                                disabled={!(isAuthorized(permissions?.Create_Edit_JobTitle) || isAuthorized(permissions?.View_JobTitle))}
                                             data-attribute="CatalogManagement_Default_Button_2" />
                                        </div>
                                        : null}
                                        <PrimaryButton
                                            text='Clear Filters'
                                            disabled={alreadyHasGridFilterValues()}
                                            onClick={handleFilterClear}
                                            className='filter-btn ms-2 clear_filter_btn'
                                         data-attribute="CatalogManagement_Default_Button_3" />
                                        <div className='excel-section pointer excel_btn' data-attribute="CatalogManagement_Default_Excel_Export_Section">
                                            <EventHandler onEvent={props?.onExportExcel} data-attribute="CatalogManagement_Default_EventHandler_2"> <img src={excel} alt='excel'/></EventHandler>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`${gridData?.current?.length !== 0 ? "softura-table" : "softura-table paginationNav"} catalog-management-table ${activeMenu === CATALOG_MANAGEMENT_ACTIVE_MENU.JOB_TITLES ? "Jobtitletable" : ""}`}>

                        {showGrid && <SofturaTable
                                data={gridData?.current ?? []}
                                columns={columnState}
                                sort={true}
                                defaultPageSize={10}
                                pageSizes={[10, 20, 50]}
                                globalSearch={false}
                                filter={true}
                                serverTotal={serverTotal}
                                fetchAction={fetchAction}
                                isServerSide={true}
                                pagesCount={pagesCount}
                                getFilterValue={setFilters}
                                key={activeMenu}
                             data-attribute="CatalogManagement_Default_Grid" />}
                        </div>                      
                    </div>
                </div>
            </Card>
        </div>
        {props?.showImportAssetPopup && (
          <ModalPopup
            closeModalPopup={props?.hideImportAssetPopup}
            ModalPopupTitle='IMPORT ASSET'
            ModalPopupType='small'
            ShowModalPopupFooter={true}
            FooterSecondaryBtnTxt='Cancel'
            FooterPrimaryBtnTxt='Import'
            ModalPopupName='import-asset-popup'
            SecondryBtnOnclick={props?.hideImportAssetPopup}
            PrimaryBtnOnclick={props?.hideImportAssetPopup}
           data-attribute="CatalogManagement_Default_ModalPopup">
            <ImportAsset/>
          </ModalPopup>
        )}
        {
            <CancelConfirmationPopup
                hideDialog={!popupContent.isDialogVisible}
                onDismiss={() => popupContent.popupOutlinebtnOnclick()}
                Popupcontent={popupContent}
                popupOutlinebtnOnclick={() => popupContent.popupOutlinebtnOnclick()}
                popupPrimarybtnOnclick={() => popupContent.popupPrimarybtnOnclick()}
            />
        }
    </>
    )
}

export default CatalogManagement;
